import React from 'react';


// import  image
import Img from '../assets/img/avisheik_barua-photo-2021_12_23_20_30-removebg.png';

const Hero = () => {
  return (
    <section
      id='home'
      className='lg:h-[85vh] flex items-center bg-primary lg:bg-cover lg:bg-center lg:bg-no-repeat py-32 lg:py-0 overflow-hidden'
    >
      <div className='container mx-auto h-full'>
        <div className='flex items-center h-full pt-8'>
          <div className='flex-1 flex flex-col items-center lg:items-start'>
            <p className='mt-14 mx-12 text-lg text-accent text-md mb-[22px]'>
              {/* Hey, I'm Avi! 👋 */}
            </p>
            <h1 className='text-4xl leading-[44px] md:text-5xl md:leading-tight lg:text-6xl lg:leading-[1.2] font-bold md:tracking-[-2px]'>
              I'm Avisheik <br /> Web Developer.
            </h1>
            <p className='pt-4 pb-8 md:pt-6 md:pb-12 max-w-[480px] text-lg text-center lg:text-left'>
              I'm a web developer from Bangladesh.
              I love creating everything, from small company sites to rich interactive web applications. If you are looking for an employer who builds aesthetic web apps, you are coming to the right place. You can get in touch with me here.
            </p>
            <div className='flex items-center gap-4 mb-10'>
              <button className='btn btn-md bg-accent hover:bg-secondary-hover md:btn-lg transition-all'>
                Work with me
              </button>
              <button className='btn btn-md bg-accent hover:bg-secondary-hover md:btn-lg transition-all'>
                <a href="https://drive.google.com/file/d/1qVxH090ycYEiT-NLduCheNiT_NLtaoYm/view?usp=sharing">My Resume</a>
              </button>
            </div>
          </div>
          <div className='hidden lg:flex flex-1 justify-end items-end h-full'>
            <img className='w-96' src={Img} alt='' />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
